const { listAttendees } = require("../renders/list_attendees");
const { handlePagination } = require("../renders/handle_pagination");

export const showAttendeeDetails = (programs) => {
  console.log(programs);
  let faculty = programs.faculty,
    attendees = programs.attendees,
    listsPerPage = 10;

  listAttendees(faculty, "faculty", "showFaculty");

  let users = attendees.map((list) => list.user);
  users.sort((a, b) =>
    a.lastName > b.lastName ? 1 : b.lastName > a.lastName ? -1 : 0
  );
  if (attendees.length < listsPerPage) {
    listAttendees(users, "attendee", "showAttendee");
  } else {
    let lists = {
      data: users,
      listsPerPage,
      type: "attendee",
      containers: {
        main: "showAttendee",
        pagination: "pageNumContainer",
      },
    };
    handlePagination(lists);
  }
};
